import { Link } from "react-router-dom";
import { Row, Col, Card } from "react-bootstrap";
import notFoundImg from "assets/images/file-searching.svg";
import { useLocation, useNavigate } from "react-router";
import { isLoggedIn } from "../../helpers/api/authService";
import { useEffect, useState } from "react";
import { DEFAULT_USER_PAGE_URL } from "constants/menu";

export function ErrorUrlNotFound() {
  const location = useLocation();
  const navigate = useNavigate();

  const [secondsElapsed, setSecondsElapsed] = useState<number>(0);

  const SECONDS_UNTIL_REDIRECT = 5;

  function getRedirectUrl(): string {
    return `/login${
      location.pathname != null ? `?redirect=${location.pathname}` : ""
    }`;
  }

  useEffect(() => {
    if (secondsElapsed >= SECONDS_UNTIL_REDIRECT) {
      // We only want to navigate if we're not logged in and get a 404.
      !isLoggedIn() && navigate(getRedirectUrl());
    }

    const timer = setInterval(
      () => setSecondsElapsed(secondsElapsed + 1),
      1000
    );
    return () => clearInterval(timer);
  }, [secondsElapsed]);

  // If user isn't logged in => auto redirect
  // If they are, then what?
  return (
    <Row className="pt-5 justify-content-md-center">
      <Col xs={12} md={7} xl={5}>
        <Card>
          <Card.Body>
            <div className="pt-sm-5 pb-4 pb-sm-5 text-center">
              <img src={notFoundImg} height="150" alt="" />
              <h1 className="text-error mt-4">404</h1>
              <h4 className="text-uppercase text-danger mt-3">
                Page Not Found
              </h4>
              <p className="text-muted mt-3">
                Oops! The page you are looking for does not exist.
              </p>
              {!isLoggedIn() && (
                <>
                  <p className="text-muted mt-1">
                    You will be redirected to the Login page in{" "}
                    {Math.max(0, SECONDS_UNTIL_REDIRECT - secondsElapsed)}{" "}
                    second
                    {SECONDS_UNTIL_REDIRECT - secondsElapsed === 1 ? "" : "s"}
                    ...
                  </p>
                </>
              )}
              <Row className="justify-content-md-center">
                <Col xs={3}></Col>
                {isLoggedIn() ? (
                  <Col xs={6}>
                    <Link
                      className="btn btn-primary mt-3"
                      to={DEFAULT_USER_PAGE_URL}
                    >
                      Back to Home
                    </Link>
                  </Col>
                ) : (
                  <Col xs={6}>
                    <Link
                      className="btn btn-primary mt-3"
                      to={getRedirectUrl()}
                    >
                      Back to Login
                    </Link>
                  </Col>
                )}
                <Col xs={3}></Col>
              </Row>
            </div>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
}
